// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import type { BetGroupOutcome } from '../../types/betGroup';
import BetGroupOutcomeContainer from '../BetGroupOutcome/BetGroupOutcomeContainer';

const Wrap = styled.div`
  display: flex;
  margin: 0.6em;
  gap: 0.8em;
`;

const Column = styled.div`
  width: 100%;
`;

const StyledBetGroupOutcomeContainer = styled(BetGroupOutcomeContainer)`
  margin-bottom: 0.6em;
  &:last-child {
    margin-bottom: 0;
  }
`;

type BetGroupColumnsProps = {
  className?: string;
  items: Array<Array<BetGroupOutcome>>;
  showPercentDistribution: boolean;
  betTemplate: string;
};

const BetGroupColumns = ({ className, items = [], showPercentDistribution, betTemplate }: BetGroupColumnsProps) => {
  const nbCols = items.length;

  return (
    <Wrap className={className}>
      {items.map((outcomes, index) => (
        <Column nbCols={nbCols} key={index}>
          {outcomes.map(({ matchId, betId, id }, i) => (
            <StyledBetGroupOutcomeContainer
              key={`betgroup-${matchId ?? ''}-${betId ?? ''}-${id ?? ''}-${i}`}
              matchId={matchId}
              betId={betId}
              oddId={id}
              betTemplate={betTemplate}
              showPercentDistribution={showPercentDistribution}
            />
          ))}
        </Column>
      ))}
    </Wrap>
  );
};

export default BetGroupColumns;
